import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, finalize, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { TokenService } from './token.service';
import { AlertServiceService } from './alert-service.service';
import { AuthService } from './auth-service.service';
import { throwError } from 'rxjs';

@Injectable()
export class InterceptInterceptor implements HttpInterceptor {
  private pendingRequests: number = 0;
  constructor(
    public router: Router,
    private spinner: NgxSpinnerService,
    public tokenService: TokenService,
    private as: AlertServiceService,
    private auth: AuthService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headersConfig: any = {
      Accept: 'application/json'
    };
    // Increase the count of pending requests
    this.pendingRequests++;
    // Start the spinner if it's not already spinning
    if (this.pendingRequests === 1) {
      this.spinner.show();
    }
    this.tokenService.getToken();
    this.tokenService.token = localStorage.getItem('token') || '';
    if (this.tokenService.getToken()) {
      if (!this.tokenService.isTokenExpired()) {
        const token = this.tokenService.getToken();
        //  const ip = document.getElementById('ip')!.innerHTML;
        if (token) {
          headersConfig['Authorization'] = `Bearer ${token}`;
          headersConfig['routePath'] = window.location.href;
          // headersConfig['partnerid'] = this.tokenService.getUser().customerId.split('-')[1] || '100000';
          headersConfig['Access-Control-Allow-Headers'] = 'Content-Type';
        }
        req = req.clone({ setHeaders: headersConfig });
      } else {
        this.as.warningToast('Session Expired! Please Login Again');
        this.auth.logout();
      }
    }
    return next.handle(req).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            const msg = 'You are not authorized to performed this action';
            this.router.navigate([`/err/${err.status}${msg}`]);
          } else if (err.status === 500) {
            const msg = err.message;
            this.router.navigate([`/err/${err.status}${msg}`]);
          } else if (err.status === 450) {
            const msg = err.message;
            this.auth.logout();
            this.router.navigate(['/auth/login']);
          } else if (err.status === 0) {
            const msg = 'Under maintainance';
            this.router.navigate([`/err/${err.status}${msg}`]);
          } else if (err.status === 503) {
            var msg = err.error.message.replaceAll(' ', '_')
            this.router.navigate([`/err/${err.status}/${msg}`]);
          } else {
            const error = err.error.message || err.error.error?.message || err.statusText || err.message;
            this.as.errorToast(error);
          }
        }
        // Re-throw the error so the calling component can handle it
        return throwError(() => err);
      }),
      finalize(() => {
        // Decrease the count of pending requests
        this.pendingRequests--;
        // Hide the spinner only when all requests are complete
        if (this.pendingRequests === 0) {
          this.spinner.hide();
        }
      })
    );
  }
}
